module.exports = __webpack_public_path__ + "static/media/share_icon.b36558ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/share_icon.png
// module id = 1853
// module chunks = 6